import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-slug-selector"
export default class extends Controller {
  connect() {
    this.inputs = Array.from(this.element.querySelectorAll("input[name='insurance_policy[product_slug]']")).filter(input => input.value === "")
    
    this.inputs.forEach(input => {
      input.remove()
    })    
    // const firstInput = this.element.querySelectorAll("input").first;
    // const secondInput = this.element.querySelectorAll("input").second;
  }
}
